export const DEFAULT_ASSETS_BASE_PATH =
  'https://images.ctfassets.net/isq5xwjfoz2m/';
export const DOMAIN_BASE_URL = 'https://www.ellenmacarthurfoundation.org';

export default DEFAULT_ASSETS_BASE_PATH;
